import React from 'react';
import { Card, CardContent } from '../ui/card';

export function SchedulingStats({ stats }) {
  return (
    <div className="grid grid-cols-2 md:grid-cols-6 gap-4">
      <Card>
        <CardContent className="pt-4 pb-4 text-center">
          <p className="text-2xl font-bold">{stats?.total_visits || 0}</p>
          <p className="text-xs text-slate-500">Total Visits</p>
        </CardContent>
      </Card>
      <Card>
        <CardContent className="pt-4 pb-4 text-center">
          <p className="text-2xl font-bold text-blue-600">{stats?.scheduled || 0}</p>
          <p className="text-xs text-slate-500">Scheduled</p>
        </CardContent>
      </Card>
      <Card>
        <CardContent className="pt-4 pb-4 text-center">
          <p className="text-2xl font-bold text-amber-600">{stats?.in_progress || 0}</p>
          <p className="text-xs text-slate-500">In Progress</p>
        </CardContent>
      </Card>
      <Card>
        <CardContent className="pt-4 pb-4 text-center">
          <p className="text-2xl font-bold text-green-600">{stats?.completed || 0}</p>
          <p className="text-xs text-slate-500">Completed</p>
        </CardContent>
      </Card>
      <Card>
        <CardContent className="pt-4 pb-4 text-center">
          <p className="text-2xl font-bold text-red-600">{stats?.missed || 0}</p>
          <p className="text-xs text-slate-500">Missed</p>
        </CardContent>
      </Card>
      <Card>
        <CardContent className="pt-4 pb-4 text-center">
          <p className="text-2xl font-bold text-purple-600">{Math.round(stats?.total_hours || 0)}h</p>
          <p className="text-xs text-slate-500">Total Hours</p>
        </CardContent>
      </Card>
    </div>
  );
}
